import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Scrollbars } from 'react-custom-scrollbars';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import moment from 'moment';
import { Form, Input, Select, Row, Col, message, DatePicker, Switch, AutoComplete, Spin, Drawer, Space, Modal } from 'antd';
import { TimePicker } from "@vaadin/react-components/TimePicker";
import ConfirmationPopup from './ConfirmationPopup';
import { caldrSuccess } from '../../../redux/CrmReduxCalls/CalendarResponse';
import { FetchAllRecentMails1 } from '../../../Api/Services/EmailApiSevices';
import { FetchAllRecentMeetings, addMeetingNote, fetchCalendarEventDetail, createMeetings, updateMeetings, cancelMeeting } from '../../../Api/Services/MeetingApiService';
import { getTimeZoneData, FetchAllAttendeeList } from '../../../Api/Services/CommonApiService';
import { AddUser } from '../style';
import TinyMCEEditor from "../EditorFolder/TinyMCE"
import { BasicFormWrapper, TopToolBoxClone } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import windowsToIanaMap from '../../../demoData/WTOIANA.json';
import legacyIanaMap from '../../../demoData/TimezoneAlise.json';
import CustomHtmlParser from '../Email/CustomHtmlParser'
import { AddIcon, CancelIcon, EditIcon } from '../../../components/Icons/Icons';

const { Option } = Select;

const Popup = ({ meetingOpen, setMeetingOpen, GetAll, calendarType, setNaCTrigger, meetingTime, taskPage, updateID, popupPageType, meetingDate, Attendees, navDate, pagefrom, MeetingCallBack, PreviousButton }) => { // emailapiValues
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const { emailapiValues } = useSelector((state) => state.EmailData);
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [hostId, setHostId] = useState()
    const [meetingType, setMeetingType] = useState(true)
    const [meetingSource, setMeetingSource] = useState("Online")
    const [fromTime, setFromTime] = useState(null);
    const [toTime, setToTime] = useState(null);
    const [fromDate, setFromDate] = useState(null)
    const [toDate, setToDate] = useState(null)
    const [participantData, setParticipantData] = useState([])
    const [allTimeZone, setAllTimeZone] = useState([])
    const [linkType, setLinkType] = useState('Contacts_Leads,Accounts');
    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [edit, setEdit] = useState(false)
    const [displayData, setDisplayData] = useState()
    const [disabled, setDisabled] = useState(false)
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [meetingDS, setMeetingDS] = useState(false)
    // const [orgDetails, setOrgDetails] = useState()
    const [meetinTZ, setMeetinTZ] = useState(false)
    const [meetinNA, setMeetinNA] = useState(false)
    const [confirmPopup, setConfirmPopup] = useState(false)
    const [meetingUniqueId, setMeetingUniqueId] = useState()
    const [PageType, setPageType] = useState()
    const [attendess, setAttendess] = useState([])
    const [attendeeDeatils, setattendeeDeatils] = useState([])
    const [commentPopup, setCommentPopup] = useState(false)
    const [comments, setComments] = useState()
    const [noteDetails, setNoteDetails] = useState({})

    function resolveTimeZone(inputTz, dropdownTimeZones) {
        const ianaTz = windowsToIanaMap[inputTz] || legacyIanaMap[inputTz] || inputTz;
        const dropdownMatch = dropdownTimeZones.find(item =>
            item.timeZone.includes(ianaTz)
        );
        if (dropdownMatch) {
            return {
                label: dropdownMatch.timeZone,
                id: dropdownMatch.timeZoneId,
            };
        }
        const fallbackMatch = dropdownTimeZones.find(item =>
            item.timeZone.toLowerCase().includes(inputTz.toLowerCase())
        );
        if (fallbackMatch) {
            return {
                label: fallbackMatch.timeZone,
                id: fallbackMatch.timeZoneId,
            };
        }
        //   const utcFallback = dropdownTimeZones.find(item =>
        //     item.timeZone.includes("Etc/UTC") || item.timeZone.includes("GMT+0:00")
        //   );
        //   return {
        //     label: utcFallback?.timeZone || "UTC",
        //     id: utcFallback?.timeZoneId || null,
        //   };
    }
    const convertTime = (timeStr, timeFormat) => {
        let hours;
        let minutes;
        let period;
        if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
            // Parse 12-hour time string
            const timeParts = timeStr.match(/(\d{1,2}):(\d{2})/);
            hours = parseInt(timeParts[1], 10);
            minutes = parseInt(timeParts[2], 10);
            period = timeStr.match(/(am|pm)/i)[0].toLowerCase();

            if (period === 'pm' && hours !== 12) {
                hours += 12;
            } else if (period === 'am' && hours === 12) {
                hours = 0;
            }
        } else {
            // Parse 24-hour time string
            const timeParts = timeStr.split(':');
            hours = parseInt(timeParts[0], 10);
            minutes = parseInt(timeParts[1], 10);
        }
        if (timeFormat === '12hrs' || timeFormat === '12-hour') {
            period = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
        }
        // No need for an else here because we return in the if above
        if (timeFormat === '24hrs' || timeFormat === '24-hour') {
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        }
        throw new Error('Invalid time format specified');
    };
    // const extractTimezoneName = (tzStr) => {
    //     const match = tzStr.match(/^(.*)\s\d{2}:\d{2}:\d{2}$/)
    //     return match ? match[1] : "";
    // };
    const OutLookDateTimeForTimeZone = (dateTime) => {
        const DateTime = `${dateTime.replace(/\.\d+/, "")}.000Z`;
        const formatedDateTime = moment(DateTime, "YYYY-MM-DDTHH:mm:ss.Z").utc().format("YYYY-MM-DDTHH:mm:ss.000000");
        return formatedDateTime;
    }
    const ZohoDateTimeForTimeZone = (dateTime) => {
        const formatedDateTime = moment(dateTime, "YYYYMMDDTHHmmssZ").utc().format("YYYY-MM-DDTHH:mm:ss.000000");
        return formatedDateTime;
    }
    const BodywithLinks = (data) => {
        const urlPattern = /(https?:\/\/[^\s]+)/g;
        const formattedMessage = data.replace(urlPattern, (url) => {
            const escapedUrl = encodeURIComponent(url);
            return `<a href="${escapedUrl}" target="_blank">${url}</a>`;
        });
        return formattedMessage.replace(/\n/g, '<br />');
    };
    const normalizeValue = (value) => {
        return value === undefined || value === null || value === "" ? "" : value;
    };
    const disabledDate = current => {
        return current && current < moment().startOf('day');
    };
    const RequiredDateFormating = (dateString) => {
        if (dateString) {
            const parsedDate = moment(dateString, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
            const formattedDate = parsedDate.format("YYYY-MM-DD");
            return formattedDate;
        }
        return null;
    };
    function formatToStandardDate(dateInput, inputFormat = "YYYY-MM-DD") {
        const date = moment(dateInput, inputFormat);
        return date.isValid() ? date.format("YYYY-MM-DD") : "";
    }
    const formatDateString = (dateString, format) => {
        return moment(dateString, "YYYY-MM-DD").format(format);
    };
    const standardizeObjectFormat = (obj) => {
        const standardizedObj = {
            id: obj.id || "",
            name: obj.name || "",
            type: obj.type || "",
            email: obj.email || ""
        };
        return standardizedObj;
    };
    const standardizeArrayFormat = (array) => {
        return array.map((obj, index) => {
            const standardizedObj = {
                id: obj.id || "",
                name: obj.name || "",
                type: obj.type || "",
                email: obj.email || ""
            };
            return {
                index,
                standardizedObj
            };
        }).sort((a, b) => a.index - b.index);
    };
    async function getPartcipants() {
        try {
            const data = await FetchAllAttendeeList()
            setParticipantData(data)
        } catch (error) {
            message.error(error)
        }
    };
    const processEmails = (responseEmails, participantData) => {
        const newUserList = responseEmails.map(response => {
            let userData = participantData.find(item => item.email.toLowerCase() === response.email.toLowerCase());
            if (!userData) {
                userData = {
                    id: "",
                    name: response.email,
                    type: "Others",
                    email: response.email,
                };
            } else {
                userData = {
                    id: userData.id,
                    name: userData.name,
                    type: userData.type,
                    email: userData.email,
                };
            }
            return userData;
        });
        return newUserList;
    };
    const processDetailsEmails = (responseEmails, participantData) => {
        const newUserList = responseEmails.map(response => {
            let userData = participantData.find(item => item.email.toLowerCase() === response.email.toLowerCase());
            if (!userData) {
                userData = {
                    id: "",
                    name: response.email,
                    type: "Others",
                    email: response.email,
                    responseStatus: response.responseStatus
                };
            } else {
                userData = {
                    id: userData.id,
                    name: userData.name,
                    type: userData.type,
                    email: userData.email,
                    responseStatus: response.responseStatus
                };
            }
            return userData;
        });
        return newUserList;
    };
    function convertFromUTCAndFormat(dateTime, profile) {
        if (!dateTime || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(toTimezone)) {
            console.warn("Invalid target time zone provided");
            return "";
        }
        const utcTime = moment.parseZone(dateTime).utc();
        const converted = utcTime.clone().tz(toTimezone);
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const timeFormat = profile?.timeFormat && profile?.timeFormat !== "" ? profile.timeFormat : "24hrs";
        const rawTime = converted.format("HH:mm");
        const formattedTime = convertTime(rawTime, timeFormat); // Assume this handles 12/24-hour format
        return { date: converted.format(dateFormat), time: formattedTime };
    }
    function convertFromUTCAndFormat1(dateTime, profile) {
        if (!dateTime || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(toTimezone)) {
            console.warn("Invalid target time zone provided");
            return "";
        }
        const utcTime = moment.utc(dateTime);
        const converted = utcTime.clone().tz(toTimezone);
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const timeFormatPref = (profile?.timeFormat?.toLowerCase() === "12hrs" || profile?.timeFormat?.toLowerCase() === '12-hour') ? "h:mm A" : "HH:mm";
        return {
            date: converted.format(dateFormat),
            time: converted.format(timeFormatPref)
        };
    }
    // const processOrgEmail = (response, participantData) => {
    //     let userData = participantData.find(item => item.email.toLowerCase() === response.email.toLowerCase());
    //     if (!userData) {
    //         userData = {
    //             id: "",
    //             name: response.email,
    //             type: "Others",
    //             email: response.email,
    //         };
    //     } else {
    //         userData = {
    //             id: userData.id,
    //             name: userData.name,
    //             type: userData.type,
    //             email: userData.email,
    //         };
    //     }
    //     return userData
    // };
    const setData = async (value) => {
        if (value) {
            let TimeZones;
            try {
                const response = await getTimeZoneData()
                TimeZones = response
                setAllTimeZone(response)
            } catch (error) {
                message.error(error)
            }
            const data = await FetchAllAttendeeList()
            setParticipantData(data)
            if (emailapiValues?.emailType === "Google") {
                // const TZone = TimeZones.find(item => item.timeZone.includes(value.start.timeZone));
                const TZone = resolveTimeZone(value.start.timeZone, TimeZones)
                const OStartData = convertFromUTCAndFormat(value?.start?.dateTime, { timeZone: TZone.label, dateFormate: profile.dateFormate })
                const OEndData = convertFromUTCAndFormat(value?.end?.dateTime, { timeZone: TZone.label, dateFormate: profile.dateFormate })
                form.setFieldsValue({
                    meetingName: value.summary,
                    startDate: moment(OStartData.date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
                    startTime: OStartData.time,
                    endDate: moment(OEndData.date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
                    endTime: OEndData.time,
                    meetingSource: value.location,
                    timeZone: TZone.label,
                    description: value.description,
                })
                // const OrgDetailsData = processOrgEmail(value.organizer, data)
                // setOrgDetails(OrgDetailsData)
                setMeetingDS(value.description)
                setMeetinTZ(TZone.label)
                setMeetinNA(value.summary)
                setHostId(profile.userId)
                setFromDate(formatToStandardDate(OStartData.date, profile.dateFormate))
                setFromTime(OStartData.time)
                setToDate(formatToStandardDate(OEndData.date, profile.dateFormate))
                setToTime(OEndData.time)
                setMeetingSource(value.location)
                setMeetingType(value.location === "Online")
                setLinkType('Contacts_Leads,Accounts')
                const attendD = value.attendees.filter(item => item.organizer === undefined || item.organizer !== true)
                const AttendeesData = processEmails(attendD, data)
                const AttendeesDetailsData = processDetailsEmails(attendD, data)
                setSelectedItems(AttendeesData)
                setAttendess(AttendeesData)
                setattendeeDeatils(AttendeesDetailsData)
                const startTimeDate = convertFromUTCAndFormat(value?.start?.dateTime, profile)
                const endTimeDate = convertFromUTCAndFormat(value?.end?.dateTime, profile)
                const FinalData = {
                    ...value,
                    startDate: startTimeDate.date,
                    startTime: startTimeDate.time,
                    endDate: endTimeDate.date,
                    endTime: endTimeDate.time,
                };
                setDisplayData(FinalData)
                setNoteDetails({
                    activityId: value?.meetingActivityId, meetingNotes:
                        (value?.meetingNotes && value?.meetingNotes !== "" && value?.meetingNotes !== "null" && value?.meetingNotes !== "undefined") ?
                            value?.meetingNotes : null
                })
            }
            if (emailapiValues?.emailType === "Outlook") {
                // const TZone = TimeZones.find(item => item.timeZone.includes(value.event.originalStartTimeZone));
                const TZone = resolveTimeZone(value.event.originalStartTimeZone, TimeZones)
                const startFrom = OutLookDateTimeForTimeZone(value.event.start.dateTime)
                const endTo = OutLookDateTimeForTimeZone(value.event.end.dateTime)
                const OStartData = convertFromUTCAndFormat1(startFrom, { timeZone: TZone.label, dateFormate: profile.dateFormate })
                const OEndData = convertFromUTCAndFormat1(endTo, { timeZone: TZone.label, dateFormate: profile.dateFormate })
                form.setFieldsValue({
                    meetingName: value.event.subject,
                    startDate: moment(OStartData.date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
                    startTime: OStartData.time,
                    endDate: moment(OEndData.date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
                    endTime: OEndData.time,
                    meetingSource: value?.event?.location?.displayName || "",
                    timeZone: TZone.label,
                    description: value.event?.bodyPreview
                })
                setMeetinTZ(TZone.label)
                setMeetinNA(value.event.subject)
                setHostId(profile.userId)
                setMeetingDS(value.event?.bodyPreview)
                setMeetingSource(value?.event?.location?.displayName || "")
                setMeetingType(value?.event?.location?.displayName === "Online")
                setLinkType('Contacts_Leads,Accounts')
                setFromDate(formatToStandardDate(OStartData.date, profile.dateFormate))
                setFromTime(OStartData.time)
                setToDate(formatToStandardDate(OEndData.date, profile.dateFormate))
                setToTime(OEndData.time)
                // const OrgDetailsData = processOrgEmail({ email: value.event.organizer.emailAddress.address }, data)
                // setOrgDetails(OrgDetailsData)
                const onlyAttendees = value.event.attendees.filter(item => item.emailAddress.address !== value.event.organizer.emailAddress.address && item.emailAddress.address.toLowerCase() !== value.event.organizer.emailAddress.address.toLowerCase()).map(item => ({
                    email: item.emailAddress.address,
                    responseStatus: item.status.response === "none"
                        ? "needsAction"
                        : item.status.response === "tentativelyAccepted"
                            ? "tentative"
                            : item.status.response,
                }));
                const AttendeesData = processEmails(onlyAttendees, data)
                const AttendeesDetailsData = processDetailsEmails(onlyAttendees, data)
                setSelectedItems(AttendeesData)
                setAttendess(AttendeesData)
                setattendeeDeatils(AttendeesDetailsData)
                const startTimeDate = convertFromUTCAndFormat1(startFrom, profile)
                const endTimeDate = convertFromUTCAndFormat1(endTo, profile)
                const FinalData = {
                    ...value.event,
                    startDate: startTimeDate.date,
                    startTime: startTimeDate.time,
                    endDate: endTimeDate.date,
                    endTime: endTimeDate.time,
                };
                setDisplayData(FinalData)
                setNoteDetails({
                    activityId: value?.event?.meetingActivityId, meetingNotes:
                        (value?.event?.meetingNotes && value?.event?.meetingNotes !== "" && value?.event?.meetingNotes !== "null" && value?.event?.meetingNotes !== "undefined") ?
                            value?.event?.meetingNotes : null
                })
            }
            if (emailapiValues?.emailType === "Zoho") {
                const startFrom = ZohoDateTimeForTimeZone(value?.events[0]?.dateandtime?.start)
                const endTo = ZohoDateTimeForTimeZone(value?.events[0]?.dateandtime?.end)
                const OStartData = convertFromUTCAndFormat1(startFrom, { timeZone: profile?.timeZone, dateFormate: profile.dateFormate })
                const OEndData = convertFromUTCAndFormat1(endTo, { timeZone: profile?.timeZone, dateFormate: profile.dateFormate })
                form.setFieldsValue({
                    meetingName: value.events[0].title,
                    startDate: moment(OStartData.date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
                    startTime: OStartData.time,
                    endDate: moment(OEndData.date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
                    endTime: OEndData.time,
                    meetingSource: value?.events[0]?.location || "",
                    timeZone: profile?.timeZone,
                    description: value?.events[0]?.description || ""
                })
                setMeetinTZ(profile?.timeZone)
                setMeetinNA(value.events[0].title)
                setHostId(profile.userId)
                setMeetingDS(value?.events[0]?.description || "")
                setMeetingSource(value?.events[0]?.location || "")
                setMeetingType(value?.events[0]?.location === "Online")
                setLinkType('Contacts_Leads,Accounts')
                setFromDate(formatToStandardDate(OStartData.date, profile.dateFormate))
                setFromTime(OStartData.time)
                setToDate(formatToStandardDate(OEndData.date, profile.dateFormate))
                setToTime(OEndData.time)
                const onlyAttendees = value?.events[0]?.attendees.filter(item => item.email !== value?.events[0].organizer && item.email.toLowerCase() !== value?.events[0].organizer.toLowerCase()).map(item => ({
                    email: item.email,
                    responseStatus: item.status === "NEEDS-ACTION" ? "needsAction" :
                        item.status === "TENTATIVE" ? "tentative" :
                            item.status === "ACCEPTED" ? "accepted" :
                                item.status === "DECLINED" ? "declined" :
                                    item.status
                }));
                const AttendeesData = processEmails(onlyAttendees, data)
                const AttendeesDetailsData = processDetailsEmails(onlyAttendees, data)
                setSelectedItems(AttendeesData)
                setAttendess(AttendeesData)
                setattendeeDeatils(AttendeesDetailsData)
                // const OrgDetailsData = processOrgEmail({ email: value?.events[0].organizer }, data)
                // setOrgDetails(OrgDetailsData)
                const startTimeDate = convertFromUTCAndFormat1(startFrom, profile)
                const endTimeDate = convertFromUTCAndFormat1(endTo, profile)
                const formatedDesc = value?.events[0]?.description ? BodywithLinks(value?.events[0]?.description) : "";
                const FinalData = {
                    ...value?.events[0],
                    startDate: startTimeDate.date,
                    startTime: startTimeDate.time,
                    endDate: endTimeDate.date,
                    endTime: endTimeDate.time,
                    description: formatedDesc,
                };
                setDisplayData(FinalData)
                setNoteDetails({
                    activityId: value?.events[0]?.meetingActivityId, meetingNotes:
                        (value?.events[0]?.meetingNotes && value?.events[0]?.meetingNotes !== "" && value?.events[0]?.meetingNotes !== "null" && value?.events[0]?.meetingNotes !== "undefined") ?
                            value?.events[0]?.meetingNotes : null
                })
            }
        }
    }
    async function getData() {
        try {
            const response = await fetchCalendarEventDetail(updateID);
            setData(response)
        } catch (error) {
            message.error(error)
        }
    }
    const handleClose = () => {
        setMeetingOpen(false)
        setEdit(false)
        form.setFieldsValue({
            meetingName: null,
            startDate: null,
            startTime: null,
            endDate: null,
            endTime: null,
            meetingSource: null,
            timeZone: null,
            description: null,
        })
        setMeetingDS(false)
        setMeetinTZ(false)
        setMeetinNA(false)
        setHostId()
        setFromDate(null)
        setFromTime(null)
        setToDate(null)
        setToTime(null)
        setMeetingSource()
        setMeetingType()
        setLinkType()
        setSelectedItems([])
        setAttendess([])
        setattendeeDeatils([])
        setDisplayData()
    };
    const MeetingStartDate = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        form.setFieldsValue({
            endDate: moment(formatDateString(formattedDate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
        })
        setToDate(formattedDate)
        setFromDate(formattedDate);
    };
    const MeetingEndDate = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setToDate(formattedDate);
    };
    const MeetingStartTime = () => {
        // const formattedTime = time ? time.format("HH:mm") : time;
        // if (formattedTime) {
        const startDate = form.getFieldValue("startTime");
        const fromDateTime = new Date(`${fromDate}T${startDate}:00`);
        const toDateTime = new Date(fromDateTime.getTime() + 30 * 60000);
        const formattedEndTime = toDateTime.toTimeString().slice(0, 5);
        // const formattedEndDate = toDateTime.toLocaleDateString("en-CA");
        form.setFieldsValue({
            endTime: formattedEndTime,
        })
        setToTime(formattedEndTime);
        setFromTime(startDate);
        // }
    };
    const MeetingEndTime = () => {
        // const formattedTime = time ? time.format("HH:mm") : time;
        // if (formattedTime) {
        const endTime = form.getFieldValue("endTime");
        setToTime(endTime);
        // }
    };
    async function getAlltimeZone() {
        try {
            const response = await getTimeZoneData()
            // const extractTimezoneName = (tzStr) => {
            //     const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            //     return match ? match[1] : "";
            // };
            // const ianaTimeZone = extractTimezoneName(profile.timeZone)
            // const TZone = response.find(item => item.timeZone.includes(profile.timeZone));
            // const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
            // const canonicalTimeZone = timeZoneAliases[timeZone] || timeZone;
            // const TimeZone = response.find(item => item.timeZone.includes(canonicalTimeZone));
            form.setFieldsValue({
                timeZone: profile.timeZone
            })
            setAllTimeZone(response)
        } catch (error) {
            message.error(error)
        }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const handleMeetingTypeChange = (value) => {
        setMeetingType(value);
        form.setFieldsValue({
            meetingSource: value ? "Online" : undefined,
        })
        setMeetingSource(value ? "Online" : undefined)
    };
    // const handleCheckboxChange = (field, isChecked) => {
    //     let updatedFields = linkType.split(',').filter(Boolean);
    //     if (isChecked) {
    //         updatedFields.push(field);
    //     } else {
    //         updatedFields = updatedFields.filter(item => item !== field);
    //     }
    //     setLinkType(updatedFields.join(','));
    // };
    const handleSearch = (value) => {
        setInputValue(value);
        if (value) {
            const filteredOptions = participantData
                .filter(option =>
                    option.name.toLowerCase().includes(value.toLowerCase())
                    || option.email.toLowerCase().includes(value.toLowerCase())
                )
                .map((option, index) => ({
                    value: index,
                    data: option,
                    label: (
                        <div className='d-flex align-items-start'>
                            <div className='diplay-center'>
                                {option.name !== null && option.name !== undefined && option.name !== "" &&
                                    <span className={`image_icon ${option.type === "Leads" ? "LeadIcon"
                                        : option.type === "User" ? "UserIcon"
                                            : option.type === "Contacts" ? "ContactIcon" : ""}`} style={{ width: '30px', height: '30px', marginRight: '10px', borderRadius: 15 }}>
                                        {option.name.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                            </div>
                            <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.name}</p>
                                <p style={{ margin: 0 }}>{option.email} ({option.type})</p>
                                {/* <p style={{ margin: 0 }}>{option.email !== null && option.email !== undefined && option.email !== "" ? `${option.email.substring(0, 10)}...` : option.email}({option.type})</p> */}
                            </div>
                            <div className='div_last'>
                                {selectedItems.some(item => JSON.stringify(standardizeObjectFormat(item)) === JSON.stringify(standardizeObjectFormat(option))) && (
                                    <FeatherIcon icon="check" size={15} className="Svg" />
                                )}
                            </div>
                        </div>
                    ),
                }));
            const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
            // If valid email and not already in the filtered options, add it
            if (isValidEmail && !filteredOptions.some(option => option.data.email === value)) {
                filteredOptions.push({
                    value: filteredOptions.length,
                    data: {
                        id: "",
                        name: value,
                        email: value,
                        type: "Others"
                    },
                    label: (
                        <div className='d-flex align-items-start'>
                            <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{value}</p>
                                <p style={{ margin: 0 }}>{value} (Others)</p>
                            </div>
                        </div>
                    )
                });
            }
            setOptions(filteredOptions);
        } else {
            setOptions([]);
        }
    };
    const handleSelect = (index) => {
        const selectedItem = standardizeObjectFormat(options[index].data);
        if (selectedItem) {
            const isSelected = selectedItems.some(item => JSON.stringify(item) === JSON.stringify(selectedItem));
            if (isSelected) {
                setSelectedItems(selectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
            } else {
                setSelectedItems([...selectedItems, selectedItem]);
            }
            setInputValue('');
            setOptions([]);
        }
    };
    const handleDeselect = (items) => {
        const selectedItem = standardizeObjectFormat(items);
        setSelectedItems(selectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
    };
    const onSubmit = async (values) => {
        // message.warning("Loading")
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        setDisabled(true)
        setIsButtonDisabled(true)
        const { meetingName, description, timeZone, startTime, endTime } = values;
        const payload =
        {
            meetingName,
            fromDate,
            fromTime: startTime,
            toDate,
            toTime: endTime,
            meetingDescription: description,
            attendees: selectedItems,
            timeZone,
            location: meetingSource
        }
        if (selectedItems.length > 0) {
            let startDateCall;
            let endDateCall;
            if (emailapiValues?.emailType === "Google" || emailapiValues?.emailType === "Outlook") {
                startDateCall = moment(fromDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                endDateCall = moment(toDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
            }
            else if (emailapiValues?.emailType === "Zoho") {
                startDateCall = moment(fromDate).startOf('day').format('YYYYMMDD')
                endDateCall = moment(toDate).endOf('day').format('YYYYMMDD')
            }
            let hideMessage;
            if (popupPageType === "Create") {
                hideMessage = message.loading("Sending Invite...", 0);
                const response = await createMeetings(linkType, payload)
                if (response.status === 201) {
                    setTimeout(() => {
                        Promise.allSettled([
                            FetchAllRecentMails1("Sent"),
                            FetchAllRecentMeetings(startDateCall, endDateCall),
                        ]).catch((err) => {
                            console.error("Unexpected error during fetch:", err);
                        }).finally(() => {
                            if (taskPage === "AddPage") {
                                setNaCTrigger("CallBack");
                            }
                        });
                    }, 2000);
                    hideMessage();
                    dispatch(caldrSuccess("ApiCall"))
                    loadingRef.current = false;
                    setDelteClick(false)
                    if (taskPage !== "AddPage" && taskPage !== "Lisingpage" && pagefrom !== "fromquery") {
                        if (calendarType === "month") {
                            if (emailapiValues?.emailType === "Google" || emailapiValues?.emailType === "Outlook") {
                                const StartDate = moment(navDate).startOf('month').startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                                const EndDate = moment(navDate).endOf('month').endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                                GetAll(StartDate, EndDate)
                            }
                            else if (emailapiValues?.emailType === "Zoho") {
                                const StartDate = moment(navDate).startOf('month').startOf('day').format('YYYYMMDD')
                                const EndDate = moment(navDate).endOf('month').endOf('day').format('YYYYMMDD')
                                GetAll(StartDate, EndDate)
                            }
                        }
                        if (calendarType === "week") {
                            if (emailapiValues?.emailType === "Google" || emailapiValues?.emailType === "Outlook") {
                                const StartDate = moment(navDate).startOf('week').startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                                const EndDate = moment(navDate).endOf('week').endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                                GetAll(StartDate, EndDate)
                            }
                            else if (emailapiValues?.emailType === "Zoho") {
                                const StartDate = moment(navDate).startOf('week').startOf('day').format('YYYYMMDD');
                                const EndDate = moment(navDate).endOf('week').endOf('day').format('YYYYMMDD');
                                GetAll(StartDate, EndDate)
                            }
                        }
                        if (calendarType === "day") {
                            if (emailapiValues?.emailType === "Google" || emailapiValues?.emailType === "Outlook") {
                                const StartDate = moment(navDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                                const EndDate = moment(navDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                                GetAll(StartDate, EndDate)
                            }
                            else if (emailapiValues?.emailType === "Zoho") {
                                const StartDate = moment(navDate).startOf('day').format('YYYYMMDD')
                                const EndDate = moment(navDate).endOf('day').format('YYYYMMDD')
                                GetAll(StartDate, EndDate)
                            }
                        }
                    }
                    message.success("Meeting created")
                    setDisabled(false)
                    setIsButtonDisabled(false)
                    if (pagefrom === "fromquery") {
                        MeetingCallBack()
                    }
                    handleClose()
                }
                else {
                    loadingRef.current = false;
                    setDelteClick(false)
                    setDisabled(false)
                    setIsButtonDisabled(false)
                    hideMessage();
                    message.error("Sending failed")
                }
            }
            if (popupPageType === "Update") {
                hideMessage = message.loading("Sending Invite...", 0);
                let queryData;
                if (emailapiValues?.emailType === "Zoho") { queryData = `?etag=${displayData?.etag}&eventId=${updateID}&linkType=${linkType}` }
                else { queryData = `?eventId=${updateID}&linkType=${linkType}` }
                const response = await updateMeetings(queryData, payload)
                setTimeout(() => {
                    Promise.allSettled([
                        FetchAllRecentMails1("Sent"),
                        FetchAllRecentMeetings(startDateCall, endDateCall),
                    ]).catch((err) => {
                        console.error("Unexpected error during fetch:", err);
                    })
                    // .finally(() => {
                    //     if (taskPage === "AddPage") {
                    //         setNaCTrigger("CallBack");
                    //     }
                    // });
                }, 2000);
                if (response.status === 200) {
                    hideMessage();
                    loadingRef.current = false;
                    setDelteClick(false)
                    if (calendarType === "month") {
                        if (emailapiValues?.emailType === "Google" || emailapiValues?.emailType === "Outlook") {
                            const StartDate = moment(navDate).startOf('month').startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                            const EndDate = moment(navDate).endOf('month').endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                            GetAll(StartDate, EndDate)
                        }
                        else if (emailapiValues?.emailType === "Zoho") {
                            const StartDate = moment(navDate).startOf('month').startOf('day').format('YYYYMMDD')
                            const EndDate = moment(navDate).endOf('month').endOf('day').format('YYYYMMDD')
                            GetAll(StartDate, EndDate)
                        }
                    }
                    if (calendarType === "week") {
                        if (emailapiValues?.emailType === "Google" || emailapiValues?.emailType === "Outlook") {
                            const StartDate = moment(navDate).startOf('week').startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                            const EndDate = moment(navDate).endOf('week').endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                            GetAll(StartDate, EndDate)
                        }
                        else if (emailapiValues?.emailType === "Zoho") {
                            const StartDate = moment(navDate).startOf('week').startOf('day').format('YYYYMMDD');
                            const EndDate = moment(navDate).endOf('week').endOf('day').format('YYYYMMDD');
                            GetAll(StartDate, EndDate)
                        }
                    }
                    if (calendarType === "day") {
                        if (emailapiValues?.emailType === "Google" || emailapiValues?.emailType === "Outlook") {
                            const StartDate = moment(navDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                            const EndDate = moment(navDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                            GetAll(StartDate, EndDate)
                        }
                        else if (emailapiValues?.emailType === "Zoho") {
                            const StartDate = moment(navDate).startOf('day').format('YYYYMMDD')
                            const EndDate = moment(navDate).endOf('day').format('YYYYMMDD')
                            GetAll(StartDate, EndDate)
                        }
                    }
                    message.success("Meeting updated")
                    setDisabled(false)
                    setIsButtonDisabled(false)
                    handleClose()
                } else {
                    loadingRef.current = false;
                    setDelteClick(false)
                    setDisabled(false)
                    setIsButtonDisabled(false)
                    hideMessage();
                    message.error("Sending failed")
                }
            }
        }
        else {
            loadingRef.current = false;
            setDelteClick(false)
            setDisabled(false)
            setIsButtonDisabled(false)
            message.error("Please add attendees")
        }
    };
    // const MeetingDelete = async (value) => {
    //     // message.warning("Loading...", 3)
    //     setDisabled(true)
    //     setIsButtonDisabled(true)
    //     const response = await axios.delete(`${getBaseURL()}/usermgmt/deleteMeeting/${value}`);
    //     if (response.status === 200) {
    //         message.success("Meeting deleted")
    //         getData()
    //         // if (calendarType === "month") {
    //         //     const StartDate = moment().startOf('month').format('YYYY-MM-DD')
    //         //     const EndDate = moment().endOf('month').format('YYYY-MM-DD')
    //         //     GetAll(StartDate, EndDate)
    //         // }
    //         // if (calendarType === "week") {
    //         //     const StartDate = moment().year(moment().year()).week(moment().week()).startOf('week').format('YYYY-MM-DD')
    //         //     const EndDate = moment().year(moment().year()).week(moment().week()).endOf('week').format('YYYY-MM-DD')
    //         //     GetAll(StartDate, EndDate)
    //         // }
    //         // if (calendarType === "day") {
    //         //     const StartDate = moment().format('YYYY-MM-DD')
    //         //     const EndDate = calendarType
    //         //     GetAll(StartDate, EndDate)
    //         // }
    //         setDisabled(false)
    //         setMeetingOpen(false)
    //         setIsButtonDisabled(false)
    //     }
    // }
    const MeetingCancel = async (value) => {
        let hideMessage;
        try {
            setDisabled(true)
            setIsButtonDisabled(true)
            hideMessage = message.loading("Remove meeting from calendar...", 0);
            let response;
            if (emailapiValues?.emailType === "Zoho") {
                const payload =
                {
                    meetingName: meetinNA,
                    fromDate,
                    fromTime,
                    toDate,
                    toTime,
                    meetingDescription: meetingDS,
                    attendees: selectedItems,
                    timeZone: meetinTZ,
                    location: meetingSource
                }
                response = await cancelMeeting(`?etag=${displayData?.etag}&eventId=${value}${(comments && comments !== "") ? `&comment=${comments}` : ""}`, payload);
            }
            else {
                response = await cancelMeeting(`?eventId=${value}${(comments && comments !== "") ? `&comment=${comments}` : ""}`);
            }
            if (response.status === 200) {
                hideMessage();
                // if (type === "Delete") {
                //     MeetingDelete(value)
                // }
                // else {
                if (calendarType === "month") {
                    if (emailapiValues?.emailType === "Google" || emailapiValues?.emailType === "Outlook") {
                        const StartDate = moment(navDate).startOf('month').startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                        const EndDate = moment(navDate).endOf('month').endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                        GetAll(StartDate, EndDate)
                    }
                    else if (emailapiValues?.emailType === "Zoho") {
                        const StartDate = moment(navDate).startOf('month').startOf('day').format('YYYYMMDD')
                        const EndDate = moment(navDate).endOf('month').endOf('day').format('YYYYMMDD')
                        GetAll(StartDate, EndDate)
                    }
                }
                if (calendarType === "week") {
                    if (emailapiValues?.emailType === "Google" || emailapiValues?.emailType === "Outlook") {
                        const StartDate = moment(navDate).startOf('week').startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                        const EndDate = moment(navDate).endOf('week').endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                        GetAll(StartDate, EndDate)
                    }
                    else if (emailapiValues?.emailType === "Zoho") {
                        const StartDate = moment(navDate).startOf('week').startOf('day').format('YYYYMMDD');
                        const EndDate = moment(navDate).endOf('week').endOf('day').format('YYYYMMDD');
                        GetAll(StartDate, EndDate)
                    }
                }
                if (calendarType === "day") {
                    if (emailapiValues?.emailType === "Google" || emailapiValues?.emailType === "Outlook") {
                        const StartDate = moment(navDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                        const EndDate = moment(navDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
                        GetAll(StartDate, EndDate)
                    }
                    else if (emailapiValues?.emailType === "Zoho") {
                        const StartDate = moment(navDate).startOf('day').format('YYYYMMDD')
                        const EndDate = moment(navDate).endOf('day').format('YYYYMMDD')
                        GetAll(StartDate, EndDate)
                    }
                }
                setConfirmPopup(false)
                setDisabled(false)
                setMeetingOpen(false)
                setIsButtonDisabled(false)
                setCommentPopup(false)
                setComments()
                message.success("Meeting cancelled")
                // }
            }
        } catch (error) {
            hideMessage();
            message.error(error);
        }
    }
    const HandleCancelDelete = (id, type) => {
        setPageType(type)
        setMeetingUniqueId(id)
        setCommentPopup(true)
    }
    const HandleCancelDelete1 = () => {
        setCommentPopup(false)
        setConfirmPopup(true)
    }
    async function saveMeetingNotes(params) {
        let hideMessage;
        try {
            setDisabled(true)
            setIsButtonDisabled(true)
            hideMessage = message.loading("Loading...", 0);
            const formattedHtmlContent = params ? `<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN"><html><head><meta content="text/html;charset=UTF-8" http-equiv="Content-Type"><link href="https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&family=Story+Script&display=swap"rel="stylesheet"></head><body><div>${params}</div></body></html>` : params;
            await addMeetingNote(noteDetails?.activityId, formattedHtmlContent)
            hideMessage();
            message.success("Notes updated")
            setDisabled(false)
            setIsButtonDisabled(false)
            getData()
        }
        catch (error) {
            setDisabled(false)
            setIsButtonDisabled(false)
            hideMessage();
            message.error(error)
        }
    }
    const openNotes = () => {
        const defaultTemplate = `
<div><strong style="color: #5a5a5a;">Meeting Purpose / Agenda:</strong></div>
<div><span class="placeholder">[Agenda item 1]</span></div>
<div>&nbsp;</div>
<div><strong style="color: #5a5a5a;">Discussion / Notes:</strong></div>
<div><span class="placeholder">[Topic 1]</span><span class="placeholder">[Key points discussed]</span><span class="placeholder">[Person responsible]</span><span class="placeholder">[Date]</span></div>
<div>&nbsp;</div>
<div><strong style="color: #5a5a5a;">Decisions Made:</strong></div>
<div><span class="placeholder">[Decision 1]</span></div>
<div>&nbsp;</div>
<div><strong style="color: #5a5a5a;">Follow-ups / Next Steps:</strong></div>
<div><span class="placeholder">[Action 1]</span> <span class="placeholder">[Owner]</span> <span class="placeholder">[Due Date]</span><br>
</div>
<div>&nbsp;</div>
<div><strong style="color: #5a5a5a;">Additional Notes / Comments:</strong></div>
<div><span class="placeholder">[Comments]</span></div>
`;
        let notesValue = noteDetails?.meetingNotes || defaultTemplate;
        let modalInstance; // declare first

        const EditorWrapper = () => {
            const [content, setContent] = React.useState(notesValue);
            const handleChange = (val) => {
                notesValue = val;
                setContent(val);
                if (modalInstance?.update) {
                    modalInstance.update({
                        okButtonProps: {
                            disabled: !val.replace(/<[^>]*>/g, "").trim(),
                        },
                    });
                }
            };
            return (
                <TinyMCEEditor
                    placeholder="Enter notes here..."
                    content={content}
                    setContent={handleChange}
                    edit
                    page="TextBox"
                    height={400}
                    selectedEntity="A"
                />
            );
        };
        modalInstance = Modal.confirm({
            icon: false,
            width: 800,
            title: (
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>{noteDetails?.meetingNotes ? "Edit Notes" : "Add Notes"}</span>
                    <Button
                        type="text"
                        onClick={() => modalInstance.destroy()}
                        style={{ fontSize: 20, padding: 0, color: "black" }}
                    >
                        ✕
                    </Button>
                </div>
            ),
            content: <EditorWrapper />,
            okText: "Save",
            cancelText: "Delete",
            okButtonProps: {
                className: "button_colorsModal",
                disabled: !notesValue?.trim(),
            },
            cancelButtonProps: {
                className: "red_colorsModal",
                style: { display: noteDetails?.meetingNotes ? "" : "none" },
            },
            onOk() {
                return saveMeetingNotes(notesValue);
            },
            onCancel() {
                return saveMeetingNotes(null);
            },
        });
    };
    useEffect(() => {
        if (meetingOpen) {
            if (popupPageType === "Update") {
                getData()
            }
            else {
                getAlltimeZone()
                getPartcipants()
                const fromDateTime = new Date(`${meetingDate}T${meetingTime}:00`);
                const toDateTime = new Date(fromDateTime.getTime() + 30 * 60000);
                const formattedEndTime = toDateTime.toTimeString().slice(0, 5);
                const formattedEndDate = toDateTime.toLocaleDateString("en-CA");
                form.setFieldsValue({
                    startDate: moment(formatDateString(meetingDate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
                    endDate: moment(formatDateString(formattedEndDate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
                    // startTime: moment(convertTime(meetingTime, profile.timeFormat ? profile.timeFormat : "24hrs"), profile.timeFormat === "12hrs" ? "hh:mm A" : "HH:mm"),
                    startTime: meetingTime,
                    endTime: formattedEndTime,
                    meetingSource: "Online"
                })
                setFromDate(meetingDate)
                setToDate(formattedEndDate)
                setFromTime(meetingTime)
                setToTime(formattedEndTime)
                setEdit(true)
                if (taskPage === "AddPage" || taskPage === "Lisingpage") {
                    setSelectedItems(Attendees)
                }
                setDisplayData("Create")
            }
        }
    }, [updateID, popupPageType, meetingOpen])
    useEffect(() => {
        const isDataDifferent = () => {
            const expectedLocation = meetingSource;
            const formattedFDate = formatDateString(fromDate, "YYYY-MM-DD")
            const formattedTDate = formatDateString(toDate, "YYYY-MM-DD")
            // const formattedFTime = convertTime(fromTime, "24hrs");
            // const formattedTTime = convertTime(toTime, "24hrs");
            const formattedFTime = fromTime
            const formattedTTime = toTime
            const standardizedAttendees = standardizeArrayFormat(attendess);
            const standardizedSelectedItems = standardizeArrayFormat(selectedItems);
            const normalizedMeetingDS = normalizeValue(displayData?.description);
            const normalizedmeetingDS = normalizeValue(meetingDS);
            const normalizedMeetinNA = normalizeValue(displayData?.summary);
            const normalizedmeetinNA = normalizeValue(meetinNA);
            const normalizedlocation = normalizeValue(displayData?.location);
            const normalizedexpectedLocation = normalizeValue(expectedLocation);
            return (
                displayData.link_type !== linkType ||
                normalizedMeetingDS !== normalizedmeetingDS ||
                normalizedMeetinNA !== normalizedmeetinNA ||
                displayData.time_zone !== meetinTZ ||
                displayData.from_date !== formattedFDate ||
                displayData.from_time !== formattedFTime ||
                displayData.to_date !== formattedTDate ||
                displayData.to_time !== formattedTTime ||
                JSON.stringify(standardizedAttendees) !== JSON.stringify(standardizedSelectedItems) ||
                normalizedlocation !== normalizedexpectedLocation
            );
        };
        if (meetingOpen) {
            if (displayData && displayData !== "Create") {
                setIsButtonDisabled(!isDataDifferent())
            }
        }
    }, [displayData, meetingDS, meetinNA, meetinTZ, fromDate, fromTime, toDate, toTime, selectedItems, meetingSource, meetingOpen])
    const FooterContent = (displayData && edit ?
        <div className='form_action_button_left'>
            <div className="form_action_button" >
                {updateID && <>
                    <Button className="red-button" disabled={disabled} size="small" onClick={() => HandleCancelDelete(updateID, "WithEmail")}>
                        <FeatherIcon icon="x-square" />Cancel Meeting
                    </Button>
                </>}
            </div>
            <div className="form_action_button">
                {(pagefrom !== "fromquery" && popupPageType === "Create") &&
                    <Button
                        className="gray-button"
                        onClick={handleClose} size="small"
                    >
                        <FeatherIcon icon="x" />Cancel
                    </Button>}
                {(popupPageType === "Create" || hostId === profile.userId) &&
                    <Button size="small" onClick={() => form.submit()} className="button_colors" loading={isButtonDisabled || deleteClick} disabled={deleteClick}>
                        {!deleteClick && <FeatherIcon icon="send" />}Send
                    </Button>
                }
            </div>
        </div>
        : false)
    const PageContent = (
        < AddUser >
            <div className="user-info-form">
                <Form style={{ width: '100%' }} form={form} name="info" colon={false} onFinishFailed={onFinishFailed}
                    onFinish={onSubmit} >
                    <BasicFormWrapper>
                        <div className="add-product-block">
                            <div style={{ margin: pagefrom === "fromquery" ? 0 : 40 }}>
                                <Row gutter={15}>
                                    <Col xs={24}>
                                        <div className="add-product-content">
                                            <Row gutter={30} style={{ padding: "0px 20px" }}>
                                                <Col span={pagefrom === "fromquery" ? 23 : 24} style={{ marginBottom: 20 }} >
                                                    <Form.Item label="Meeting Name" name="meetingName" id="meetingName" rules={edit ? [{ required: true, message: 'Enter meeting name' },] : [{ required: false, }]}>
                                                        {edit ? <Input placeholder='Enter Meeting Name' onChange={(e) => setMeetinNA(e.target.value)} /> :
                                                            <> {emailapiValues?.emailType === "Google" ?
                                                                displayData?.summary && displayData?.summary !== "" ? displayData.summary : "No Subject"
                                                                : emailapiValues?.emailType === "Outlook" ?
                                                                    displayData?.subject && displayData?.subject !== "" ? displayData.subject : "No Subject"
                                                                    : emailapiValues?.emailType === "Zoho" ?
                                                                        displayData?.title && displayData?.title !== "" ? displayData.title : "No Subject" :
                                                                        displayData?.summary && displayData?.summary !== "" ? displayData.summary : "No Subject"}</>}
                                                    </Form.Item>
                                                </Col>
                                                <Col span={pagefrom === "fromquery" ? 23 : 24} style={{ marginBottom: 20 }} >
                                                    <Form.Item label={<>{edit && <span className="required-symbol">* </span>} Attendees</>}>
                                                        {edit ? selectedItems.length > 0 &&
                                                            <div className='Div_flex'>
                                                                {selectedItems.map((item, index) => (
                                                                    <div className='share_image' key={index} title={`${item.name} (${item.type})`} style={{ cursor: "default" }}>
                                                                        <span className={`image_icon ${item.type === "Leads" ? "LeadIcon"
                                                                            : item.type === "User" ? "UserIcon"
                                                                                : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                                                            {item.name.slice(0, 1).toUpperCase()}
                                                                        </span>
                                                                        <span>{`${item.name.substring(0, 10)}...`}</span>
                                                                        {edit && <FeatherIcon icon="x" size={15} className="Svg" onClick={() => handleDeselect(item)} />}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            :
                                                            attendeeDeatils?.length > 0 &&
                                                            <div className='Div_flex'>
                                                                {attendeeDeatils?.map((item, index) => (
                                                                    <div className='share_image' key={index} title={`${item.name} (${item.type}) (${item.responseStatus === "accepted" ? "Accepted" :
                                                                        item.responseStatus === "needsAction" ? "Not Accepted" :
                                                                            item.responseStatus === "tentative" ? "Tentative" : "Declined"
                                                                        })`} style={{ cursor: "default" }}>
                                                                        <span className={`image_icon ${item.type === "Leads" ? "LeadIcon"
                                                                            : item.type === "User" ? "UserIcon"
                                                                                : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                                                            {item?.name?.slice(0, 1).toUpperCase()}
                                                                        </span>
                                                                        <span>{`${item.name?.substring(0, 10)}...`}</span>
                                                                        <FeatherIcon icon={item.responseStatus === "needsAction" ? "clock" : item.responseStatus === "accepted" ? "thumbs-up" :
                                                                            item.responseStatus === "tentative" ? "help-circle" : "thumbs-down"}
                                                                            style={{
                                                                                color: item.responseStatus === "needsAction" ? "orange" : item.responseStatus === "accepted" ? "green" :
                                                                                    item.responseStatus === "tentative" ? "gray" : "red"
                                                                            }}
                                                                            size={15} className="Svg" />
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        }
                                                        {edit &&
                                                            <TopToolBoxClone>
                                                                <AutoComplete
                                                                    onSearch={handleSearch}
                                                                    onSelect={handleSelect}
                                                                    options={options}
                                                                    value={inputValue}
                                                                    onChange={setInputValue}
                                                                >
                                                                    <Input placeholder="Add Attendees" />
                                                                </AutoComplete>
                                                            </TopToolBoxClone>
                                                        }
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6} style={{ marginBottom: 20 }} className='MeetingDatePicker'>
                                                    <Form.Item label="Start Date" name="startDate"
                                                        id="startDate" dependencies={["endDate"]} rules={edit ? [{ required: true, message: 'Please select start date' },
                                                        ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                const endDate = getFieldValue("endDate");
                                                                if (!value || !endDate || value <= endDate) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject(new Error("Start date cannot be after End date"));
                                                            },
                                                        }),
                                                        ] : [{ required: false }]}>
                                                        {edit ? <DatePicker
                                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                            value={fromDate ? moment(fromDate, "YYYY-MM-DD") : null}
                                                            onChange={MeetingStartDate} allowClear={false}
                                                            // disabledDate={(current) => {
                                                            //     const today = moment().startOf('day');
                                                            //     const end = toDate ? moment(toDate, "YYYY-MM-DD").endOf('day') : null;
                                                            //     return current && (
                                                            //         current < today ||  // disable past
                                                            //         (end && current > end) // disable future after end date
                                                            //     );
                                                            // }}
                                                            disabledDate={disabledDate}
                                                        />
                                                            :
                                                            <> {displayData?.startDate}</>}
                                                    </Form.Item>
                                                </Col>
                                                <Col span={5} style={{ marginBottom: 20 }} className='MeetingDatePicker'>
                                                    <Form.Item label="Start Time" name="startTime" dependencies={["startDate", "endDate", "endTime"]}
                                                        rules={edit ? [{ required: true, message: 'Please select start time' }, ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                const startDate = getFieldValue("startDate");
                                                                const endDate = getFieldValue("endDate");
                                                                const endTime = getFieldValue("endTime");
                                                                if (!startDate || !endDate || !value || !endTime) {
                                                                    return Promise.resolve();
                                                                }
                                                                const startDateTime = moment(
                                                                    `${startDate.format("YYYY-MM-DD")} ${value}`,
                                                                    "YYYY-MM-DD HH:mm"
                                                                );
                                                                const endDateTime = moment(
                                                                    `${endDate.format("YYYY-MM-DD")} ${endTime}`,
                                                                    "YYYY-MM-DD HH:mm"
                                                                );
                                                                if (startDateTime.isBefore(endDateTime)) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject(new Error("Start time should be before end time"));
                                                            },
                                                        }),
                                                        ] : [{ required: false }]}>
                                                        {edit ?
                                                            <TimePicker className="custom-timepicker"
                                                                // clearButtonVisible 
                                                                step={1800} placeholder="Start Time" onChange={MeetingStartTime} />
                                                            // <TimePicker
                                                            //     value={fromTime ? moment(fromTime, "HH:mm") : null}
                                                            //     format={profile.timeFormat === "12hrs" ? "hh:mm A" : "HH:mm"}
                                                            //     onChange={MeetingStartTime}
                                                            // />
                                                            :
                                                            <>
                                                                {displayData?.startTime}
                                                            </>}
                                                    </Form.Item>
                                                </Col>
                                                <Col span={2} style={{ marginBottom: 20 }}>
                                                    <FeatherIcon icon="arrow-right" size={40} style={{ marginTop: edit ? 30 : 5, marginLeft: edit ? 0 : -30 }} />
                                                </Col>
                                                <Col span={pagefrom === "fromquery" ? 5 : 6} style={{ marginBottom: 20 }} className='MeetingDatePicker'>
                                                    <Form.Item label="End Date" name="endDate"
                                                        id="endDate"
                                                        dependencies={["startDate"]}
                                                        rules={edit ? [
                                                            { required: true, message: "Please select end date" },
                                                            ({ getFieldValue }) => ({
                                                                validator(_, value) {
                                                                    const startDate = getFieldValue("startDate");
                                                                    if (!value || !startDate || value >= startDate) {
                                                                        return Promise.resolve();
                                                                    }
                                                                    return Promise.reject(new Error("End date must be after Start date"));
                                                                },
                                                            }),
                                                        ] : [{ required: false }]}>
                                                        {edit ? <DatePicker allowClear={false}
                                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                            value={toDate ? moment(toDate, "YYYY-MM-DD") : null}
                                                            onChange={MeetingEndDate}
                                                            // disabledDate={disabledDate}
                                                            disabledDate={(current) => {
                                                                const start = fromDate ? moment(fromDate, "YYYY-MM-DD").startOf("day") : null;
                                                                return current && start && current < start;
                                                            }}
                                                        />
                                                            :
                                                            <>{displayData?.endDate}</>}
                                                    </Form.Item>
                                                </Col>
                                                <Col span={5} style={{ marginBottom: 20 }} className='MeetingDatePicker'>
                                                    <Form.Item label="End Time" name="endTime" dependencies={["startDate", "endDate", "startTime"]} rules={edit ? [{ required: true, message: 'Please select end time' },
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            const startDate = getFieldValue("startDate");
                                                            const endDate = getFieldValue("endDate");
                                                            const startTime = getFieldValue("startTime");
                                                            if (!startDate || !endDate || !startTime || !value) {
                                                                return Promise.resolve();
                                                            }
                                                            const startDateTime = moment(
                                                                `${startDate.format("YYYY-MM-DD")} ${startTime}`,
                                                                "YYYY-MM-DD HH:mm"
                                                            );
                                                            const endDateTime = moment(
                                                                `${endDate.format("YYYY-MM-DD")} ${value}`,
                                                                "YYYY-MM-DD HH:mm"
                                                            );
                                                            if (endDateTime.isAfter(startDateTime)) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(new Error("End time should be after start time"));
                                                        },
                                                    }),
                                                    ] : [{ required: false }]}>
                                                        {edit ?
                                                            <TimePicker
                                                                // clearButtonVisible 
                                                                className="custom-timepicker" step={1800} placeholder="End Time" onChange={MeetingEndTime} />
                                                            // <TimePicker
                                                            //     value={toTime ? moment(toTime, "HH:mm") : null}
                                                            //     format={profile.timeFormat === "12hrs" ? "hh:mm A" : "HH:mm"}
                                                            //     onChange={MeetingEndTime}
                                                            // /> 
                                                            :
                                                            <>
                                                                {displayData?.endTime}
                                                            </>}
                                                    </Form.Item>
                                                </Col>
                                                <Col span={pagefrom === "fromquery" ? 23 : 24} style={{ marginBottom: 20 }} >
                                                    <Form.Item label="Time Zone" id="timeZone" name="timeZone" rules={edit ? [{ required: true, message: 'Please select time zone' },] : [{ required: false }]}>
                                                        {edit ? <Select
                                                            style={{ width: '100%' }}
                                                            showSearch
                                                            placeholder="Select Time Zone"
                                                            optionFilterProp="children"
                                                            filterOption={(input, option) =>
                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }
                                                            onChange={(value) => setMeetinTZ(value)}
                                                        >
                                                            {allTimeZone !== undefined && allTimeZone.map((option, i) => (
                                                                <Option key={i} value={option.timeZone}>
                                                                    {option.timeZone}
                                                                </Option>
                                                            ))}
                                                        </Select> :
                                                            <>{profile?.timeZone}</>}
                                                    </Form.Item>
                                                </Col>
                                                <Col span={pagefrom === "fromquery" ? 23 : 24} style={{ marginBottom: 20 }} >
                                                    <Form.Item label="Location" id="meetingSource" name="meetingSource">
                                                        {edit ? <Input placeholder="Enter meeting location" disabled={meetingType} value={meetingSource} onChange={(e) => setMeetingSource(e.target.value)}
                                                            suffix={
                                                                <div style={{ height: "48px", display: 'flex', alignItems: 'center' }}>
                                                                    <div style={{ marginRight: 8 }}>
                                                                        {meetingType ? 'Online' : 'In-Person'}
                                                                    </div>
                                                                    <div>
                                                                        <Switch
                                                                            checked={meetingType}
                                                                            onChange={handleMeetingTypeChange}
                                                                            style={{
                                                                                width: '40px',
                                                                                height: '18px',
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            } /> :
                                                            <>
                                                                {emailapiValues?.emailType === "Google" ? displayData?.location
                                                                    : emailapiValues?.emailType === "Outlook" ?
                                                                        displayData?.location?.displayName === "Online" ?
                                                                            displayData?.url : displayData?.location?.displayName
                                                                        : displayData?.location === "Online" ? displayData?.url
                                                                            : displayData?.location}</>}
                                                    </Form.Item>
                                                </Col>
                                                {/* <Col span={pagefrom === "fromquery"?23:24} style={{ marginBottom: 20 }} >
                                                            <div>
                                                                <Checkbox
                                                                    checked
                                                                    disabled
                                                                >
                                                                    Link this meeting to <b>Contacts/Leads</b> in the &quot;Attendees&quot; field
                                                                </Checkbox>
                                                            </div>
                                                            <div >
                                                                <Checkbox
                                                                    disabled={!edit}
                                                                    checked={linkType.includes('Accounts')}
                                                                    onChange={(e) => handleCheckboxChange('Accounts', e.target.checked)}
                                                                >
                                                                    Link this meeting to <b>Accounts</b> related to contacts in the &quot;Attendees&quot; field
                                                                </Checkbox>
                                                            </div>
                                                            <div >
                                                                <Checkbox
                                                                    disabled={!edit}
                                                                    checked={linkType.includes('Deals')}
                                                                    onChange={(e) => handleCheckboxChange('Deals', e.target.checked)}
                                                                >
                                                                    Link this meeting to <b>Deals</b> related to contacts in the &quot;Attendees&quot; field
                                                                </Checkbox>
                                                            </div>
                                                        </Col> */}
                                                <Col span={pagefrom === "fromquery" ? 23 : 24} style={{ marginBottom: 20 }}>
                                                    <Form.Item label="Meeting Description" name="description" id="description">
                                                        {edit ? (
                                                            <Input.TextArea
                                                                rows={3}
                                                                maxLength={2500}
                                                                showCount
                                                                placeholder="Enter Description"
                                                                onChange={(e) => setMeetingDS(e.target.value)}
                                                            />
                                                        ) : (
                                                            (() => {
                                                                const isGoogle = emailapiValues?.emailType === "Google";
                                                                const isOutlook = emailapiValues?.emailType === "Outlook";
                                                                const isZoho = emailapiValues?.emailType === "Zoho";

                                                                const description = isGoogle
                                                                    ? displayData?.description
                                                                    : isOutlook
                                                                        ? displayData?.body?.content
                                                                        : isZoho
                                                                            ? displayData?.description
                                                                            : displayData?.description;

                                                                const meetingLink = isGoogle
                                                                    ? displayData?.hangoutLink
                                                                    : isOutlook
                                                                        ? displayData?.onlineMeeting?.joinUrl || displayData?.onlineMeetingUrl
                                                                        : displayData?.hangoutLink;

                                                                const hasDescription = description && description !== "";
                                                                const hasLink = meetingLink && meetingLink !== "";

                                                                return (
                                                                    <div>
                                                                        {hasDescription ? (
                                                                            <p>
                                                                                {isOutlook || isZoho ? (
                                                                                    <CustomHtmlParser html={description} key={1} />
                                                                                ) : (
                                                                                    description
                                                                                )}
                                                                            </p>
                                                                        ) : null}

                                                                        {hasLink ? (
                                                                            <p>
                                                                                <a href={meetingLink} target="_blank" rel="noopener noreferrer">
                                                                                    {meetingLink}
                                                                                </a>
                                                                            </p>
                                                                        ) : null}

                                                                        {!hasDescription && !hasLink && <p>No Description</p>}
                                                                    </div>
                                                                );
                                                            })()
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                                {noteDetails?.activityId ?
                                                    <>
                                                        <Col span={24} style={{ marginBottom: 20 }} >
                                                            <div>
                                                                <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                                                                    <div style={{
                                                                        fontSize: "18px",
                                                                        fontWeight: "600",
                                                                        lineHeight: "22px"
                                                                    }}>Meeting Notes</div>
                                                                    {(!edit && noteDetails?.activityId && noteDetails?.meetingNotes && noteDetails?.meetingNotes !== "" && noteDetails?.meetingNotes !== "null" && noteDetails?.meetingNotes !== "undefined") && (
                                                                        <div className='Hover-Refresh2 back-hover1 able-style2'
                                                                            role="button"
                                                                            tabIndex={0} title='Edit'
                                                                            onClick={() => openNotes()}
                                                                            onKeyDown={(event) => {
                                                                                if (event.key === 'Enter' || event.key === ' ') {
                                                                                    openNotes()
                                                                                }
                                                                            }}
                                                                            aria-label='edit'
                                                                        > <EditIcon width={16} height={16} />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className='Form-Text1'>Only meetings with recorded notes will count toward lead, contact, deal or account scoring. Adding notes increases the score weightage as it reflects meaningful engagement</div>
                                                            </div>
                                                            <div style={{ marginTop: 10 }}>
                                                                {noteDetails?.meetingNotes &&
                                                                    noteDetails.meetingNotes !== "" &&
                                                                    noteDetails.meetingNotes !== "null" &&
                                                                    noteDetails.meetingNotes !== "undefined" ? (
                                                                    <CustomHtmlParser html={noteDetails.meetingNotes} key={1} />
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </div>
                                                        </Col>
                                                        {(!edit && noteDetails?.activityId) ? (
                                                            noteDetails?.meetingNotes && noteDetails?.meetingNotes !== "" && noteDetails?.meetingNotes !== "null" && noteDetails?.meetingNotes !== "undefined" ? <></> :
                                                                <div className='Hover-Refresh2 back-hover1 able-style2'
                                                                    role="button"
                                                                    tabIndex={0} title='Add'
                                                                    onClick={() => openNotes()}
                                                                    onKeyDown={(event) => {
                                                                        if (event.key === 'Enter' || event.key === ' ') {
                                                                            openNotes()
                                                                        }
                                                                    }}
                                                                    aria-label='add'
                                                                > <AddIcon width={20} height={20} marginRight={5} /> Add Note</div>) : ""}
                                                    </> : <></>
                                                }
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </BasicFormWrapper>
                </Form>
            </div>
        </AddUser >
    )
    return (
        <>{pagefrom === "fromquery" ?
            <>
                {displayData ? <div>
                    <div>{PageContent}</div>
                    <div> <Row gutter={15}>
                        <Col xs={24}>
                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                <Col span={23} style={{ marginBottom: 20 }}>
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        margin: "50px 0px 0px"
                                    }}>
                                        <Button size="small"
                                            className="gray-button" onClick={() => PreviousButton()}>
                                            <FeatherIcon icon="arrow-left" size={16} />
                                            Previous
                                        </Button>
                                        {FooterContent}
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    </div>
                </div>
                    : <div className="spin">
                        <Spin />
                    </div>}</>
            : <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                closable={false}
                placement="right"
                title={popupPageType === "Update" ? "Update Meeting" : "Schedule Meeting"}
                open={meetingOpen}
                width="70%"
                extra={
                    < Space >
                        {popupPageType === "Update" && !edit ?
                            <div className='Hover-Refresh2 back-hover1 able-style'
                                role="button"
                                tabIndex={0} title='Edit'
                                onClick={() => setEdit(true)}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        setEdit(true)
                                    }
                                }}
                                aria-label='edit'
                            > <EditIcon height={20} width={20} /></div> : <></>}
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => handleClose()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    handleClose()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space >
                }
                footer={FooterContent}
            >
                {displayData ? <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    {PageContent}
                </Scrollbars>
                    :
                    <div className="spin">
                        <Spin />
                    </div>
                }
            </Drawer>}
            {confirmPopup && <ConfirmationPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} GetCallback={MeetingCancel} deleteId={meetingUniqueId} page={PageType} />} {/* DeleteApi={MeetingDelete} */}
            {commentPopup && <Modal
                title="Cancel comments"
                open={commentPopup}
                onCancel={() => { setCommentPopup(false) }}
                footer={[<Button size="small" disabled={isButtonDisabled}
                    onClick={() => HandleCancelDelete1()} className="button_colors">
                    <FeatherIcon icon="send" /> Send
                </Button>]}
            >
                <Input.TextArea
                    rows={3}
                    value={comments}
                    placeholder="Add your comment (optional)"
                    onChange={(e) => {
                        setComments(e.target.value)
                    }}
                />
            </Modal>
            }
        </>
    );
};

Popup.propTypes = {
    meetingOpen: PropTypes.bool.isRequired,
    setMeetingOpen: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    // meetingProp: PropTypes.object.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    taskPage: PropTypes.string.isRequired,
    updateID: PropTypes.number.isRequired,
    popupPageType: PropTypes.string.isRequired,
    meetingDate: PropTypes.string.isRequired,
    meetingTime: PropTypes.string.isRequired,
    calendarType: PropTypes.string.isRequired,
    Attendees: PropTypes.array.isRequired,
    // emailapiValues: PropTypes.object.isRequired,
    navDate: PropTypes.string.isRequired,
    pagefrom: PropTypes.string.isRequired,
    MeetingCallBack: PropTypes.func.isRequired,
    PreviousButton: PropTypes.func.isRequired,
};

export default Popup;
